import {Component, OnInit, ViewChild} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {jqxGridComponent} from '../../../../assets/jqwidgets-ts/angular_jqxgrid';
import {jqxWindowComponent} from '../../../../assets/jqwidgets-ts/angular_jqxwindow';

import {_RuleService} from '../../../ng1-services/rule.service';
import {_Ng1UserService} from '../../../ng1-services/user.service';
import {_GridService} from '../../../ng1-services/grid.service';

import {Grid} from '../../../interfaces/grid.interface';
import {_RuleCurrencyCrossService} from "../../../ng1-services/rule-currency-cross.service";
import {_RuleNdfCurrencyService} from "../../../ng1-services/rule-ndf-currency.service";
import {_RuleHedgeRatioService} from "../../../services/ruleHedgeRatio.service";

declare var $: any, dump: any;

@Component({
  selector: 'targets',
  templateUrl: './targets.component.html',
  styleUrls: ['./targets.component.css'],
})

export class TargetsBranch implements OnInit {

  @ViewChild('confirmHedgeFullExposureChange') confirmHedgeFullExposureChange: jqxWindowComponent;
  @ViewChild('currencyHedgeRatioGrid') currencyHedgeRatioGrid: jqxGridComponent;
  @ViewChild('securityHedgeRatioGrid') securityHedgeRatioGrid: jqxGridComponent;
  @ViewChild('currencyCrossGrid')currencyCrossGrid: jqxGridComponent;
  @ViewChild('ndfCurrencyGrid')ndfCurrencyGrid: jqxGridComponent;

  //grid settings
  private currencyHedgeRatioSettings: Grid;
  private securityHedgeRatioSettings: Grid;
  private currencyCrossSettings: Grid;
  private ndfCurrencySettings: Grid;
  private rule: any;
  private hedgingFullyEnabled: any;

  constructor(private titleService: Title,
              private ruleService: _RuleService,
              private ruleHedgeRatioService: _RuleHedgeRatioService,
              private ruleCurrencyCrossService: _RuleCurrencyCrossService,
              private ruleNdfCurrencyService: _RuleNdfCurrencyService,
              private gridService: _GridService,
              private userService: _Ng1UserService) {

  }

  ngOnInit() {
    this.titleService.setTitle("WiseRisk | Targets");

    this.userService.GetCurrentUser().then((currentUser) => {
      return this.ruleService.GetRule(currentUser.organizationId);
    }).then((rule) => {
      this.rule = rule;
      this.hedgingFullyEnabled = this.rule.hedgingFullyEnabled;
    });

    //Load Grids
    this.loadCurrencyHedgeRatios();
    this.loadSecurityHedgeRatios();
    this.loadCrossCurrencies();
    this.loadNdfCurrencies();
  }

  cancelUpdateHedgeFullExposure() {
    this.hedgingFullyEnabled = !this.hedgingFullyEnabled;
    this.confirmHedgeFullExposureChange.close();
  }

  clickHedgeFullExposure() {
    this.confirmHedgeFullExposureChange.open();
  };

  updateHedgeFullExposure() {
    if (this.rule.hedgingFullyEnabled != this.hedgingFullyEnabled) {
      this.rule.hedgingFullyEnabled = this.hedgingFullyEnabled;
      this.ruleService.UpdateRule(this.rule).then((rule) => {
        if (this.rule.hedgingFullyEnabled) {
          this.gridService.SuccessMsg('currencyHedgeRatioMsg', 'Hedge 100% Enabled');
        } else {
          this.gridService.SuccessMsg('currencyHedgeRatioMsg', 'Hedge 100% Disabled');
        }
      }, () => {
        this.gridService.ErrorMsg('currencyHedgeRatioMsg', 'Error updating Hedge 100%.');
      });
    }
    this.confirmHedgeFullExposureChange.close();
  }

  loadCurrencyHedgeRatios() {
    this.currencyHedgeRatioSettings = null;
    this.ruleHedgeRatioService.getHedgeRatios('CURRENCY_RATIO').then((data) => {

      var msgContainer = "currencyHedgeRatioMsg";
      var accounts = this.gridService.GetAccountDataAdapter(false).records;
      var accountGroups = this.gridService.GetAccountGroupDataAdapter().records;
      let entityDropDown = null;
      var source = {
        id: 'ruleHedgeRatioId',
        localdata: data,
        datafields: [
          {
            name: 'ruleHedgeRatioId',
            type: 'int'
          }, {
            name: 'organizationId',
            type: 'int'
          }, {
            name: 'ruleType',
            type: 'string'
          }, {
            name: 'EntityTypeDisplay',
            value: "entityType",
            values: {
              source: this.gridService.GetEntityTypeDataAdapter().records,
              value: 'value',
              name: 'display',
            },
          }, {
            name: 'entityType',
            type: 'string'
          }, {
            name: 'EntityIDDisplay',
            value: "entityId",
            values: {
              source: accounts,
              value: 'entityId',
              name: 'display',
            },
          }, {
            name: 'entityId',
            type: 'string'
          }, {
            name: 'baseCurrency',
            type: 'string'
          }, {
            name: 'localCurrency',
            type: 'string'
          }, {
            name: 'alternateCurrency',
            type: 'string'
          }, {
            name: 'ratio',
            type: 'string'
          }, {
            name: 'range',
            type: 'string'
          }
        ],
        updaterow: (rowid, rowdata, commit) => {
          rowdata.ruleType = "CURRENCY_RATIO";

          //If one is '(All)' they are both '(All)'. ruleHedgeRatioService translates this to null in create/update.
          if(rowdata.baseCurrency == '(All)' || rowdata.localCurrency == '(All)'){
            rowdata.baseCurrency = '(All)';
            rowdata.localCurrency = '(All)';
          }

          //New Row
          if (rowdata.rowId < 1) {
            this.ruleHedgeRatioService.createHedgeRatio(rowdata).toPromise().then((data) => {
              this.gridService.SuccessMsg(msgContainer, 'Currency Hedge Ratio Added');
              this.loadCurrencyHedgeRatios();
            }, (data) => {
              this.gridService.ErrorMsg(msgContainer, data);
            });
          } else {
            this.ruleHedgeRatioService.updateHedgeRatio(rowdata).toPromise().then((data) => {
              this.gridService.SuccessMsg(msgContainer, 'Currency Hedge Ratio Updated');
              this.loadCurrencyHedgeRatios();
            }, (data) => {
              this.gridService.ErrorMsg(msgContainer, data);
            });
          }
        },
        deleterow: (rowdata) => {
          this.ruleHedgeRatioService.deleteHedgeRatio(rowdata.ruleHedgeRatioId).toPromise().then((data) => {
            this.gridService.SuccessMsg(msgContainer, 'Currency Hedge Ratio Deleted');
            this.loadCurrencyHedgeRatios();
          }, (data) => {
            this.gridService.ErrorMsg(msgContainer, data);
          });
        },
        refresh: () => {
          this.loadCurrencyHedgeRatios();
        },
        getGrid: () => {
          return this.currencyHedgeRatioGrid;
        }
      };
      this.currencyHedgeRatioSettings = {
        source: source,
        dataAdapter: new $.jqx.dataAdapter(source),
        columns: [{
          text: 'Scope',
          columntype: 'dropdownlist',
          datafield: 'entityType',
          displayfield: "EntityTypeDisplay",
          width: '150',
          createeditor: (row, cellvalue, editor) => {
            editor.jqxDropDownList({
              source: this.gridService.GetEntityTypeDataAdapter(),
              displayMember: "display",
              valueMember: "value"
            });
          },
          initeditor: (row, cellvalue, editor, celltext, cellwidth, cellheight) => {
            editor.on('change', (event) => {
              var entityType = event.args.item.value;
              this.gridService.ConfigureEntityEditor(entityDropDown, entityType, true);
            });
          }
        }, {
          text: 'Name',
          columntype: 'dropdownlist',
          datafield: 'entityId',
          displayfield: "EntityIDDisplay",
          width: '150',
          createeditor: (row, cellvalue, editor, celltext, cellwidth, cellheight) => {
            // set entityDropDown, so it can be configured by EntityType editor change
            entityDropDown = editor;
            var entityType = this.currencyHedgeRatioGrid.getcellvalue(row, "entityType");
            this.gridService.ConfigureEntityEditor(entityDropDown, entityType, false);
          },
          initeditor: (row, cellvalue, editor, celltext, cellwidth, cellheight) => {
            // set entityDropDown, so it can be configured by EntityType editor change
            entityDropDown = editor;
          },
          cellsrenderer: (row, columnfield, value, defaulthtml, columnproperties, rowdata) => {
            return this.gridService.SetInitialEntityDisplay(rowdata.entityType, rowdata.entityId);
          }
        }, {
          text: 'Base Ccy',
          columntype: 'dropdownlist',
          datafield: 'baseCurrency',
          width: '100',
          createeditor: (row, cellvalue, editor) => {
            editor.jqxDropDownList({
              source: this.gridService.GetCurrencyDataAdapter(false, true),
              displayMember: "currency",
              valueMember: "currency"
            });
          }
        }, {
          text: 'Local Ccy',
          columntype: 'dropdownlist',
          datafield: 'localCurrency',
          width: '100',
          createeditor: (row, cellvalue, editor) => {
            editor.jqxDropDownList({
              source: this.gridService.GetCurrencyDataAdapter(false, true),
              displayMember: "currency",
              valueMember: "currency"
            });
          }
        }, {
          text: 'Alt Ccy',
          columntype: 'dropdownlist',
          datafield: 'alternateCurrency',
          width: '100',
          createeditor: (row, cellvalue, editor) => {
            editor.jqxDropDownList({
              source: this.gridService.GetCurrencyDataAdapter(true, false),
              displayMember: "currency",
              valueMember: "currency"
            });
          }
        }, {
          text: 'Hedge Ratio',
          columntype: 'textbox',
          datafield: 'ratio'
        }, {
          text: 'Range (+/-)',
          columntype: 'textbox',
          datafield: 'range'
        }
        ],
        renderstatusbar: (statusbar: any) => {
          this.gridService.RenderStatusBar(statusbar, source);
        }
      };
    });
  }

  loadSecurityHedgeRatios() {
    this.securityHedgeRatioSettings = null;
    this.ruleHedgeRatioService.getHedgeRatios('SECURITY_RATIO').then((data) => {
      var msgContainer = "securityHedgeRatioMsg";
      var accounts = this.gridService.GetAccountDataAdapter(false).records;
      var accountGroups = this.gridService.GetAccountGroupDataAdapter().records;
      let entityDropDown = null;
      var source = {
        id: 'ruleHedgeRatioId',
        localdata: data,
        datafields: [{
          name: 'ruleHedgeRatioId',
          type: 'int'
        }, {
          name: 'organizationId',
          type: 'int'
        }, {
          name: 'ruleType',
          type: 'string'
        }, {
          name: 'entityType',
          type: 'string'
        }, {
          name : 'EntityTypeDisplay',
          value: "entityType",
          values: {
            source: this.gridService.GetEntityTypeDataAdapter().records,
            value: 'value',
            name: 'display'
          }
        }, {
          name: 'entityId',
          type: 'string'
        }, {
          name : 'EntityIDDisplay',
          value: "entityId",
          values: {
            source: accounts,
            value: 'entityId',
            name: 'display'
          }
        }, {
          name: 'externalSecurityId',
          type: 'string'
        }, {
          name: 'alternateCurrency',
          type: 'string'
        }, {
          name: 'ratio',
          type: 'string'
        }],
        updaterow: (rowid, rowdata, commit) => {
          rowdata.ruleType = "SECURITY_RATIO";
          //New Row
          if (rowdata.rowId < 1) {
            this.ruleHedgeRatioService.createHedgeRatio(rowdata).toPromise().then((data) => {
              this.gridService.SuccessMsg(msgContainer, 'Security Hedge Ratio Added');
              this.loadSecurityHedgeRatios();
            }, (data) => {
              this.gridService.ErrorMsg(msgContainer, data);
            });
          } else {
            this.ruleHedgeRatioService.updateHedgeRatio(rowdata).toPromise().then((data) => {
              this.gridService.SuccessMsg(msgContainer, 'Security Hedge Ratio Updated');
              this.loadSecurityHedgeRatios();
            }, (data) => {
              this.gridService.ErrorMsg(msgContainer, data);
            });
          }
        },
        deleterow: (rowdata) => {
          this.ruleHedgeRatioService.deleteHedgeRatio(rowdata.ruleHedgeRatioId).toPromise().then((data) => {
            this.gridService.SuccessMsg(msgContainer, 'Security Hedge Ratio Deleted');
            this.loadSecurityHedgeRatios();
          }, (data) => {
            this.gridService.ErrorMsg(msgContainer, data);
          });
        },
        refresh: () => {
          this.loadSecurityHedgeRatios();
        },
        getGrid: () => {
          return this.securityHedgeRatioGrid;
        }
      };
      this.securityHedgeRatioSettings = {
        source: source,
        dataAdapter: new $.jqx.dataAdapter(source),
        columns: [{
          text: 'Scope',
          columntype: 'dropdownlist',
          datafield: 'entityType',
          displayfield: "EntityTypeDisplay",
          width: '150',
          createeditor: (row, cellvalue, editor) => {
            editor.jqxDropDownList({
              source: this.gridService.GetEntityTypeDataAdapter(),
              displayMember: "display",
              valueMember: "value"
            });
          },
          initeditor: (row, cellvalue, editor, celltext, cellwidth, cellheight) => {
            editor.on('change', (event) => {
              var entityType = event.args.item.value;
              this.gridService.ConfigureEntityEditor(entityDropDown, entityType, true);
            });
          }
        }, {
          text: 'Name',
          columntype: 'dropdownlist',
          datafield: 'entityId',
          displayfield: "EntityIDDisplay",
          width: '150',
          createeditor: (row, cellvalue, editor, celltext, cellwidth, cellheight) => {
            // set entityDropDown, so it can be configured by EntityType editor change
            entityDropDown = editor;
            var entityType = this.securityHedgeRatioGrid.getcellvalue(row, "entityType");
            this.gridService.ConfigureEntityEditor(entityDropDown, entityType, false);
          },
          initeditor: (row, cellvalue, editor, celltext, cellwidth, cellheight) => {
            // set entityDropDown, so it can be configured by EntityType editor change
            entityDropDown = editor;
          },
          cellsrenderer: (row, columnfield, value, defaulthtml, columnproperties, rowdata) => {
            return this.gridService.SetInitialEntityDisplay(rowdata.entityType, rowdata.entityId);
          }
        }, {
          text: 'Security',
          columntype: 'textbox',
          datafield: 'externalSecurityId'
        }, {
          text: 'Alt Ccy',
          columntype: 'dropdownlist',
          datafield: 'alternateCurrency',
          createeditor: (row, cellvalue, editor) => {
            editor.jqxDropDownList({
              source: this.gridService.GetCurrencyDataAdapter(true, false),
              displayMember: "currency",
              valueMember: "currency"
            });
          }
        }, {
          text: 'Hedge Ratio',
          columntype: 'textbox',
          datafield: 'ratio'
        }],
        renderstatusbar: (statusbar: any) => {
          this.gridService.RenderStatusBar(statusbar, source);
        }
      };
    });
  }

  loadCrossCurrencies (){
    this.currencyCrossSettings = null;
    this.ruleCurrencyCrossService.GetRuleCurrencyCross().then((data) => {
      var msgContainer = "currencyCrossMsg";
      var source = {
        datatype: 'json',
        localdata: data,
        datafields: [
          {
            name: 'organizationId',
            type: 'int'
          }, {
            name: 'ruleCurrencyCrossId',
            type: 'int'
          }, {
            name : 'currencyPair',
            type : 'string'
          }, {
            name : 'CurrencyPairDisplay',
            value : 'currencyPair',
            values: {
              source: this.gridService.GetCurrencyPairDataAdapter(true).records,
              value: 'currencyPair',
              name: 'currencyPair'
            }
          }, {
            name: 'crossCurrency',
            type: 'string'
          }
        ],
        updaterow: (rowid, rowdata, commit) => {
          //New Row
          if (rowdata.rowId < 1) {
            this.ruleCurrencyCrossService.CreateRuleCurrencyCross(rowdata).then((data) => {
              this.gridService.SuccessMsg(msgContainer, 'Currency Cross Added');
              this.loadCrossCurrencies();
            }, (data) => {
              this.gridService.ErrorMsg(msgContainer, data);
            });
          } else {
            this.ruleCurrencyCrossService.UpdateRuleCurrencyCross(rowdata).then((data) => {
              this.gridService.SuccessMsg(msgContainer, 'Currency Cross Updated');
              this.loadCrossCurrencies();
            }, (data) => {
              this.gridService.ErrorMsg(msgContainer, data);
            });
          }
        },
        deleterow: (rowdata) => {
          this.ruleCurrencyCrossService.DeleteRuleCurrencyCross(rowdata.ruleCurrencyCrossId).then((data) => {
            this.gridService.SuccessMsg(msgContainer, 'Currency Cross Deleted');
            this.loadCrossCurrencies();
          }, (data) => {
            this.gridService.ErrorMsg(msgContainer, data);
          });
        },
        refresh: () => {
          this.loadCrossCurrencies();
        },
        getGrid: () => {
          return this.currencyCrossGrid;
        }
      };
      this.currencyCrossSettings = {
        source: source,
        dataAdapter: new $.jqx.dataAdapter(source),
        columns: [
          {
            text : 'Ccy Pair',
            columntype : 'dropdownlist',
            datafield : 'currencyPair',
            displayfield : 'CurrencyPairDisplay',
            width : '150',
            createeditor : (row, cellvalue, editor) => {
              editor.jqxDropDownList({
                source : this.gridService.GetCurrencyPairDataAdapter(false),
                displayMember : "currencyPair",
                valueMember : "currencyPair"
              });
            }
          }, {
            text: 'Cross Ccy',
            columntype: 'dropdownlist',
            datafield: 'crossCurrency',
            width: '100',
            createeditor: (row, cellvalue, editor) => {
              editor.jqxDropDownList({
                source: this.gridService.GetCurrencyDataAdapter(false, false),
                displayMember: "currency",
                valueMember: "currency"
              });
            }
          }
        ],
        renderstatusbar: (statusbar: any) => {
          this.gridService.RenderStatusBar(statusbar, source);
        }
      };
    });
  }

  loadNdfCurrencies (){
    this.ndfCurrencySettings = null;
    this.ruleNdfCurrencyService.GetRuleNdfCurrency().then((data) => {
      var msgContainer = "ndfCurrencyMsg";
      var source = {
        datatype: 'json',
        localdata: data,
        datafields: [
          {
            name: 'organizationId',
            type: 'int'
          }, {
            name: 'ruleNdfCurrencyId',
            type: 'int'
          }, {
            name : 'currency',
            type : 'string'
          }, {
            name : 'fundingExcluded',
            type : 'bool'
          }, {
            name : 'enabled',
            type : 'bool'
          }
        ],
        updaterow: (rowid, rowdata, commit) => {
          //New Row
          if (rowdata.rowId < 1) {
            this.ruleNdfCurrencyService.CreateRuleNdfCurrency(rowdata).then((data) => {
              this.gridService.SuccessMsg(msgContainer, 'Restricted Currency Added');
              this.loadNdfCurrencies();
            }, (data) => {
              this.gridService.ErrorMsg(msgContainer, data);
            });
          } else {
            this.ruleNdfCurrencyService.UpdateRuleNdfCurrency(rowdata).then((data) => {
              this.gridService.SuccessMsg(msgContainer, 'Restricted Currency Updated');
              this.loadNdfCurrencies();
            }, (data) => {
              this.gridService.ErrorMsg(msgContainer, data);
            });
          }
        },
        deleterow: (rowdata) => {
          this.ruleNdfCurrencyService.DeleteRuleNdfCurrency(rowdata.ruleNdfCurrencyId).then((data) => {
            this.gridService.SuccessMsg(msgContainer, 'Restricted Currency Deleted');
            this.loadNdfCurrencies();
          }, (data) => {
            this.gridService.ErrorMsg(msgContainer, data);
          });
        },
        refresh: () => {
          this.loadNdfCurrencies();
        },
        getGrid: () => {
          return this.ndfCurrencyGrid;
        }
      };
      this.ndfCurrencySettings = {
        source: source,
        dataAdapter: new $.jqx.dataAdapter(source),
        columns: [
          {
            text: 'Currency',
            columntype: 'dropdownlist',
            datafield: 'currency',
            width: '150',
            createeditor: (row, cellvalue, editor) => {
              editor.jqxDropDownList({
                source: this.gridService.GetCurrencyDataAdapter(false, false),
                displayMember: "currency",
                valueMember: "currency"
              });
            }
          },
          {
            text: 'Funding Excluded',
            columntype: 'checkbox',
            datafield: 'fundingExcluded',
            width: '150'
          }
        ],
        renderstatusbar: (statusbar: any) => {
          this.gridService.RenderStatusBar(statusbar, source);
        }
      };
    });
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/rules/targets/targets.component.ts